import {Roles} from "../../../../shared/Configs/DatabaseConsts";

export const TASK_ATTRIBUTION = [
    {text: 'aggregatorTask', value: Roles.AGGREGATOR},
    {text: 'clientTask', value: Roles.REGULAR},
    {text: 'leadTask', value: Roles.LEAD},
    {text: 'staffTask', value: Roles.BASICMANAGER},
    {text: 'generalTask', value: 'general'},
    {text: 'personalTask', value: 'personal'}
]

export const TASKS_TABS = {
    today: 'today',
    tomorrow: 'tomorrow',
    yesterday: 'yesterday',
    range: 'range',
    overdue: 'overdue'
}

export const TASK_SWITCHES = {
    open: 'open',
    completed: 'completed',
    productivity: 'productivity'
}

export const TASKS_SETTINGS_TABS = {
    taskTypes: 'taskTypes',
    autoTasks: 'autoTasks',
    taskNotifications: 'taskNotifications',
    roleVisibility: 'roleVisibility'
}

export const DATE_FIELD_OPTIONS = {
    taskCreatedAt: 'taskCreatedAt',
    taskDueDate: 'taskDueDate'
}

export const ROLES_FOR_VISIBILITY_SETTING = [
    Roles.MANAGER,
    Roles.SALESMANAGER,
    Roles.SALESMAN,
    Roles.SERVICE,
    Roles.RECEPTIONLIST,
]
